import './forgotPassword.css'

import React, { useState } from "react";

import {forgot_password} from "../../redux/actions";
import { Form, FormGroup, Input, FormFeedback } from "reactstrap";
import Regex from "../../utilities/regex";
import { useDispatch } from 'react-redux';


const ForgotPassword = () => {

    
const [email , setEmail] =useState("")
const [errors ,seterrors] =useState({email: false, })
const dispatch=useDispatch();

const onHandleChange = ({ target: { name, value } }) => {
    if(name === "email"){
        seterrors({...errors,[name]: false,})
        setEmail(value.replace(/\s/g, ''))

    }else {
        seterrors({...errors,[name]: false,})
        setEmail(value)

    }
  };



  const handleSubmit = (e) => {
    e.preventDefault();

    if (!Regex.email(email.trim())) {
        seterrors( { ...errors,  email: true,  })
    }


    if (!errors.email) {
        
        dispatch(  forgot_password({values:{email:email}}))

    }
  };    
    return (
        <div className="col-12 wrapper main-bggrey p-0">
            {/* <div className="col-12 inner-page-content fPassword-100 login-page px-0 d-flex justify-content-center align-items-center ">
                <div id="login" className="col-sm-12  my-4">
                    <div className="login-container col-sm-8 col-md-6 col-lg-4 col-xl-4 m-auto bg-white boxshadow border-radius8">
                        <div id="login-row" className="row justify-content-center align-items-center ">
                            <div id="login-column" className="w-100">
                                <h3 className="text-center page-head font-weight-bold  txtcolor">Forgot Password?</h3>
                                <h5 className="text-center txt-lghtblue page-subhead mb-4 pb-2">Enter your details to recieve a reset link</h5>
                                <div id="login-box" className="col-md-12">
                                    <form id="login-form" className="form site-form" action="" method="post">

                                        <div className="form-group mb-4">
                                            <input type="email" name="userlname" id="userlname" className="form-control input-style min-input" placeholder="Email address" />
                                        </div>

                                        <div className="form-group m-0">
                                            <button type="submit" className="btn  text-white w-100 btn-custom min-input mt-2" onclick="window.location.href='mail-sent.html'; return false;" >
                                                <span>
                                                    Send Reset Link
                                                </span>
                                            </button>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}


<div className="col-12 inner-page-content login-page px-0  login-100 d-flex justify-content-center align-items-center ">
        <div id="login" className="col-sm-12  my-4">
          <div className="login-container col-sm-8 col-md-6 col-lg-4 col-xl-4 m-auto bg-white boxshadow border-radius8">
            <div
              id="login-row"
              className="row justify-content-center align-items-center"
            >
              <div id="login-column" className="w-100">
                <h3 className="text-center page-head font-weight-bold  txtcolor">
                  Forgot Password?
                </h3>
                <h5 className="text-center txt-lghtblue page-subhead mb-4 pb-2">
                  Enter your details to receive a reset link
                </h5>
                <div id="login-box" className="col-md-12">
                  <Form className="form site-form" onSubmit={handleSubmit}>
                    <FormGroup className="form-group mb-4">
                      <Input
                        id="email"
                        className="form-control input-style min-input"
                        name="email"
                        placeholder="Email address"
                        type="text"
                        value={email}
                        onChange={onHandleChange}
                        invalid={(email && !Regex.email(email)) || errors.email}
                      />
                      <FormFeedback id="email-err">
                        Please enter a valid email address.
                      </FormFeedback>
                    </FormGroup>
                    <FormGroup className="form-group m-0">
                      <button
                        type="submit"
                        className="btn  text-white w-100 btn-custom min-input mt-2"
                        // onclick="window.location.href='mail-sent.html'; return false;"
                      >
                        <span>Send Reset Link</span>
                      </button>
                    </FormGroup>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        </div>
    );
}

export default ForgotPassword;